export default __webpack_public_path__ + "static/media/p1-min.d14d5897.png";